let $ = require('jquery');
let Backbone = require("backbone");
let POS = require("../POS.js");

let main = function () {
    var ActivityModalView = Backbone.View.extend({
        el: "#activityModal",

        events: {
            'click .join-activity': 'joinActivity',
            'click .show-analytics-help': 'showAnalyticsHelp',
            'click .show-weixin-help': 'showWeixinHelp',
            'click .refresh': 'refresh'
        },
        show: function(){
            this.$el.modal("show");
        },
        hide: function() {
            this.$el.modal("hide");
        },
        joinActivity: function(event) {
            $('#bigLoading').removeClass('hidden');
            var button = $(event.target);
            var uuid = button.data("uuid");
            var result = $.post('/activity/joinActivity', {uuid: uuid});
            var self = this;
            result.done(function (res) {
                button.hide();
                $("#activityModal .result-message").removeClass("hidden");
                $("#activityModal .result-message").html(res.message);
                $('#bigLoading').addClass('hidden');
            });
        },
        showAnalyticsHelp: function() {
            window.open("/help/analytics");
        },
        showWeixinHelp: function() {
            window.open("/help/weixin");
        },
        refresh: function() {
            window.location.reload();
        }
    });

    return ActivityModalView;
};

let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/ActivityModalView.js